<template>
  <div>
    <!-- <footer class="">
      <div>
        <img class="w-100" src="../assets/imgs/foroprosa2024/patrocinadores.jpg" alt="Foro Prosa">
      </div>
    </footer> -->

    <footer class="pt-4 pt-lg-5">
      <div>
        <img
          class="w-100 d-block d-lg-none"
          src="../assets/imgs/foroprosa2024/foro2024_footer_mobile.jpg"
          alt="Foro Prosa"
        />
        <img
          class="w-100 d-none d-lg-block"
          src="../assets/imgs/foroprosa2024/foro2024_footer_desk.png"
          alt="Foro Prosa"
        />
      </div>
    </footer>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  components: {
    // carousel,
  },
  data() {
    return {
      diamante: null,
      oro: null,
      platino: null,
      jade: null,
    };
  },
  mounted: function () {
    console.log("footer montando");
    this.diamante = this.shuffle(this.$store.state.diamante);
    this.platino = this.shuffle(this.$store.state.platino);
    this.oro = this.shuffle(this.$store.state.oro);
    this.jade = this.shuffle(this.$store.state.jade);
  },
  methods: {
    shuffle(array) {
      array.sort(() => Math.random() - 0.5);
      return array;
    },
  },
};
</script>

